export default __webpack_public_path__ + "6bfb79d32a9ff2e894d8fcb30bf14be2.svg";